<template>
    <div class="page">
        <div class="geoanalise-ocorrencias">
            <!-- Mapa -->
            <div class="mapa-wrapper" :class="{ disabled: isLoading }">
                <gmap-map
                    ref="mapRef"
                    :center="center"
                    :zoom="zoomLevel"
                    :options="mapOptions"
                    @zoom_changed="checkIfOpenedWindowInCluster"
                >
                    <gmap-info-window
                        ref="infoWindow"
                        :position="infoWindow.position"
                        :opened="infoWindow.open"
                        @closeclick="infoWindow.open = false"
                    >
                        <!-- Janela de informações da agro visita item, aberta ao clicar no Pin -->
                        <div class="info-window">
                            <div class="info-details">
                                <div v-if="infoWindow.item.agrovisita.cliente">
                                    <span>{{ $t('produtor') }}: </span>
                                    {{ infoWindow.item.agrovisita.cliente.nome }}
                                </div>

                                <div v-if="infoWindow.item.agrovisita.propriedade">
                                    <span>{{ $t('propriedade') }}: </span>
                                    {{ infoWindow.item.agrovisita.propriedade.nome }}
                                </div>

                                <div v-if="infoWindow.item.agrovisita.cultura">
                                    <span>{{ $t('tipo-cultura') }}: </span>
                                    {{ infoWindow.item.agrovisita.cultura.descricao }}
                                </div>

                                <div v-if="infoWindow.item.agrovisita.motivovisita">
                                    <span>{{ $t('motivo') }}: </span>
                                    {{ infoWindow.item.agrovisita.motivovisita.descricao }}
                                </div>

                                <div v-if="infoWindow.item.agrovisita.assuntovisita">
                                    <span>{{ $t('assunto-visita') }}: </span>
                                    {{ infoWindow.item.agrovisita.assuntovisita.descricao }}
                                </div>

                                <div v-if="infoWindow.item.ocorrencia.agroTipoOcorrencia">
                                    <span>{{ $t('agro-tipoocorrencia') }}: </span>
                                    <!--gerando html com v-html para icones dinamicos -->
                                    <span
                                        v-html="
                                            buildIcon(
                                                infoWindow.item.ocorrencia.agroTipoOcorrencia,
                                                false
                                            )
                                        "
                                        ref="icone"
                                        class="icon has-text-dark"
                                    >
                                    </span>
                                    -
                                    {{ infoWindow.item.ocorrencia.agroTipoOcorrencia.descricao }}
                                </div>

                                <!-- Botão levando para as informações extras da agro visita item -->
                                <button
                                    class="btn-expand"
                                    slot="trigger"
                                    @click="goToDetalhes(infoWindow.item.agrovisita.uuid)"
                                >
                                    {{ $t('detalhes') }}
                                </button>
                            </div>
                        </div>
                    </gmap-info-window>
                </gmap-map>
            </div>

            <!-- Botão de retrair -->
            <div
                ref="retractBtn"
                class="retract-button"
                :class="{ 'hide-control-right-btn': !showOcorrencias }"
                v-show="!isLoading && !$root.gmapsFailure"
            >
                <div class="btn-wrapper" @click="showOcorrencias = !showOcorrencias">
                    <b-icon :icon="showOcorrencias ? 'chevron-right' : 'chevron-left'" />
                </div>
            </div>

            <!-- Lista de Ocorrencias - Dentro do Mapa -->
            <div
                ref="listaOcorrencias"
                class="control-right"
                :class="{ 'hide-control-right': !showOcorrencias }"
                v-show="!isLoading && !$root.gmapsFailure"
            >
                <!-- Alert container movido pra dentro da lista que fica dentro do maps; Permite que os avisos apareçam em full screen -->
                <alert-container :messages="msgs" />
                <div class="control-container">
                    <!-- Abas -->
                    <div class="control-tabs">
                        <ul class="nav nav-tabs">
                            <li
                                v-for="(a, i) in abas"
                                :class="{ active: abaAtual == i }"
                                :key="i"
                                @click="abaAtual = i"
                            >
                                <a data-toggle="tab" href="#">{{ $t(a) }}</a>
                            </li>
                        </ul>
                    </div>
                    <!-- Aba Ocorrencias -->
                    <div class="lista-tipoocorrencias" v-show="abaAtual == 0">
                        <div class="table-controls">
                            <div
                                class="status-header"
                                :class="{ ordered: isOrderedBy == 'nome', disabled: isSearching }"
                                @click="orderBy('nome', sortDirection, true)"
                            >
                                {{ $t('tipo-ocorrencias') }}
                                <svg
                                    class="svg-icons"
                                    v-if="isOrderedBy == 'nome' && sortDirection == false"
                                >
                                    <use
                                        :xlink:href="
                                            require('@/assets/img/icons/arrow-up.svg') + '#layer'
                                        "
                                    ></use>
                                </svg>
                                <svg
                                    class="svg-icons"
                                    v-if="isOrderedBy == 'nome' && sortDirection == true"
                                >
                                    <use
                                        :xlink:href="
                                            require('@/assets/img/icons/arrow-down.svg') + '#layer'
                                        "
                                    ></use>
                                </svg>
                            </div>
                            <div
                                class="cliente-header"
                                :class="{ ordered: isOrderedBy == 'qtd', disabled: isSearching }"
                            >
                                {{ $t('ocorrencias') }}
                                <svg
                                    class="svg-icons"
                                    v-if="isOrderedBy == 'qtd' && sortDirection == false"
                                >
                                    <use
                                        :xlink:href="
                                            require('@/assets/img/icons/arrow-up.svg') + '#layer'
                                        "
                                    ></use>
                                </svg>
                                <svg
                                    class="svg-icons"
                                    v-if="isOrderedBy == 'qtd' && sortDirection == true"
                                >
                                    <use
                                        :xlink:href="
                                            require('@/assets/img/icons/arrow-down.svg') + '#layer'
                                        "
                                    ></use>
                                </svg>
                            </div>
                        </div>
                        <div class="columns lista-wrapper is-mobile">
                            <div class="column is-paddingless lista-container">
                                <div
                                    class="columns is-multiline is-mobile"
                                    :class="isSearching ? 'disabled' : ''"
                                >
                                    <div
                                        class="column is-full lista-item"
                                        v-for="(to, i) in tiposocorrencias"
                                        :key="i"
                                        :class="to.isLoading ? 'disabled' : ''"
                                    >
                                        <div class="tipos-ocorrencias-info">
                                            <div class="info-left">
                                                <!-- Icone do Tipo Ocorrencia -->
                                                <span
                                                    v-html="buildIcon(to, true)"
                                                    ref="icone"
                                                    class="icon has-text-dark"
                                                    :style="`color: ${
                                                        to.qtd > 0 ? to.cor : '#999999'
                                                    };`"
                                                >
                                                </span>
                                                <!-- Checkbox de seleção para mostrar/esconder os pins no mapa -->
                                                <div class="check-div">
                                                    <label class="check-box" v-show="to.qtd > 0">
                                                        <input
                                                            :ref="`chk-${to.idagro_tipoocorrencia}`"
                                                            type="checkbox"
                                                            v-model="
                                                                visibilityMap[to.descricao].checked
                                                            "
                                                            @change="toggleTipoOcorrencia(to)"
                                                        />
                                                        <span class="checkmark" />
                                                    </label>
                                                </div>
                                                <!-- Icone de seta para abrir e visualizar os itens internos -->
                                                <div
                                                    @click="openDetails(to)"
                                                    :style="
                                                        to.qtd == 0 ? 'padding-right: 16px;' : ''
                                                    "
                                                >
                                                    <b-icon
                                                        :icon="
                                                            to.detailsOpen
                                                                ? 'chevron-down'
                                                                : 'chevron-right'
                                                        "
                                                        size="is-small"
                                                        custom-size="mdi-18px"
                                                        v-if="to.qtd > 0"
                                                    />
                                                </div>
                                                <div
                                                    style="width: 100%; margin-top: 2px"
                                                    @click="openDetails(to)"
                                                >
                                                    <span>
                                                        {{
                                                            to.descricao.toUpperCase() +
                                                            '( ' +
                                                            to.qtd +
                                                            ')'
                                                        }}
                                                    </span>
                                                </div>
                                            </div>
                                            <div
                                                class="info-right info-right-item"
                                                @click="openDetails(to)"
                                            >
                                                {{ to.qtd }} -
                                                {{
                                                    format(totalItems > 0 ? to.qtd / totalItems : 0)
                                                }}
                                            </div>
                                        </div>
                                        <!-- Itens internos do Tipo Ocorrencia, neste caso Usuários -->
                                        <b-collapse :open="to.detailsOpen" class="sub-menu">
                                            <div
                                                class="column is-full lista-usuarios"
                                                v-for="(u, j) in to.usuarios"
                                                :key="j"
                                            >
                                                <div class="usuarios-info">
                                                    <div class="info-left">
                                                        <label class="check-box">
                                                            <input
                                                                v-if="
                                                                    visibilityMap[to.descricao][
                                                                        u.idusuario
                                                                    ]
                                                                "
                                                                :ref="`chk-${to.idagro_tipoocorrencia}-u-${u.idusuario}`"
                                                                type="checkbox"
                                                                v-model="
                                                                    visibilityMap[to.descricao][
                                                                        u.idusuario
                                                                    ].visible
                                                                "
                                                                @change="toggleUsuario(to, u)"
                                                            />
                                                            <span class="checkmark" />
                                                        </label>
                                                        <div
                                                            @click="openDetails(u)"
                                                            :style="
                                                                u.qtd == 0
                                                                    ? 'padding-right: 16px;'
                                                                    : ''
                                                            "
                                                        >
                                                            <b-icon
                                                                :icon="
                                                                    u.detailsOpen
                                                                        ? 'chevron-down'
                                                                        : 'chevron-right'
                                                                "
                                                                size="is-small"
                                                                custom-size="mdi-18px"
                                                                v-if="u.qtd > 0"
                                                            />
                                                        </div>
                                                        <div
                                                            style="width: 100% margin-top: 2px;"
                                                            @click="openDetails(u)"
                                                        >
                                                            <span class="text">
                                                                {{ u.nome }}
                                                            </span>
                                                        </div>
                                                        <div
                                                            class="info-right info-right-user"
                                                            @click="openDetails(u)"
                                                        >
                                                            {{ u.qtd }} -
                                                            {{
                                                                format(
                                                                    to.qtd > 0 ? u.qtd / to.qtd : 0
                                                                )
                                                            }}
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Itens internos dos usuários, neste caso ocorrências -->
                                                <b-collapse :open="u.detailsOpen" class="sub-menu">
                                                    <div
                                                        class="column is-full lista-ocorrencias"
                                                        v-for="(o, k) in u.ocorrencias"
                                                        :key="k"
                                                    >
                                                        <div class="ocorrencias-info">
                                                            <div class="info-left">
                                                                <label class="check-box">
                                                                    <input
                                                                        v-if="
                                                                            visibilityMap[
                                                                                to.descricao
                                                                            ][u.idusuario][
                                                                                o.idagro_ocorrencia
                                                                            ]
                                                                        "
                                                                        :key="
                                                                            to.descricao +
                                                                            '-' +
                                                                            u.idusuario +
                                                                            '-' +
                                                                            o.idagro_ocorrencia
                                                                        "
                                                                        type="checkbox"
                                                                        v-model="
                                                                            visibilityMap[
                                                                                to.descricao
                                                                            ][u.idusuario][
                                                                                o.idagro_ocorrencia
                                                                            ].visible
                                                                        "
                                                                        @change="
                                                                            toggleOcorrencia(
                                                                                to,
                                                                                u,
                                                                                o
                                                                            )
                                                                        "
                                                                    />
                                                                    <span class="checkmark" />
                                                                </label>

                                                                <div style="width: 100%">
                                                                    <span class="text">
                                                                        {{ o.nomepopular }}
                                                                    </span>
                                                                </div>

                                                                <div
                                                                    class="info-right info-right-ocorrencia"
                                                                >
                                                                    {{ o.visitas.length }} -
                                                                    {{
                                                                        format(
                                                                            u.qtd > 0
                                                                                ? o.visitas.length /
                                                                                    u.qtd
                                                                                : 0
                                                                        )
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </b-collapse>
                                            </div>
                                        </b-collapse>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-count">
                            <div v-if="!isLoading" :class="isSearching ? 'disabled' : ''">
                                {{ $t('ocorrencias') }}: {{ totalItems }}
                            </div>
                        </div>
                    </div>
                    <!-- Aba Filtros -->
                    <div class="filtros-main" v-show="abaAtual == 1">
                        <div class="columns is-variable is-12 is-flex-wrap">
                            <div class="column is-12">
                                <verified-date-picker
                                    dateType="startDate"
                                    v-model="datainicio"
                                    :endDate="datafim"
                                    :title="'data-inicio'"
                                    position="is-bottom-left"
                                    :required="erroDataInicio"
                                    :invalid="erroDataInicio"
                                    inForm
                                />
                            </div>
                            <div class="column is-12">
                                <verified-date-picker
                                    dateType="endDate"
                                    v-model="datafim"
                                    :startDate="datainicio"
                                    :title="'data-fim'"
                                    position="is-bottom-left"
                                    :required="erroDataFim"
                                    :invalid="erroDataFim"
                                    inForm
                                />
                            </div>
                            <div class="column is-12">
                                <vss-select
                                    id="filter-safra"
                                    ref="safraSelect"
                                    title="agro-safra"
                                    :placeholder="
                                        safraSelect.length > 0
                                            ? 'selecione-uma-opcao'
                                            : 'sem-opcao-de-selecao'
                                    "
                                    searchable
                                    clearable
                                    multiple
                                    :options="safraSelect"
                                    v-model="safraSelected"
                                    :loading="safraLoading"
                                    @search="loadSafra"
                                    :closeOnSelect="false"
                                />
                            </div>
                            <div class="column is-12">
                                <vss-select
                                    id="filter-cultura"
                                    ref="culturaSelect"
                                    title="agro-cultura"
                                    :placeholder="
                                        culturaSelect.length > 0
                                            ? 'selecione-uma-opcao'
                                            : 'sem-opcao-de-selecao'
                                    "
                                    searchable
                                    clearable
                                    multiple
                                    :options="culturaSelect"
                                    v-model="culturaSelected"
                                    :loading="culturaLoading"
                                    @search="loadCultura"
                                    :closeOnSelect="false"
                                />
                            </div>

                            <div class="column is-12 button-box">
                                <b-button
                                    type="is-primary"
                                    icon-right="filter"
                                    @click="carregarDados"
                                    class="full-size"
                                    :disabled="isLoading"
                                >
                                    {{ $t('filtrar') }}
                                    <button-loader :isSaving="isSaving" />
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// @71176 - Criado relatório de geoanalise por ocorrencia
// import FiltroRelatorioService from "@/services/FiltroRelatorioService";
import GeoanaliseOcorrenciaService from '@/services/agro/geoanalise/GeoanaliseOcorrenciaService';
import AgroVisitaItemService from '@/services/agro/agrovisita/AgroVisitaItemService';
import CulturaService from '@/services/agro/CulturaService';
import SafraService from '@/services/agro/SafraService';
import Cluster from 'vue2-google-maps/src/components/cluster';
import paleta from '@/functions/color/paleta.js';
import Message from '@/models/Message';
import MarkerClusterer from 'marker-clusterer-plus';

export default {
    props: {
        filtro: {
            type: Object,
            default() {
                return {
                    inicio: null,
                    fim: null,
                    safras: [],
                    culturas: [],
                };
            },
        },
    },
    data() {
        return {
            cluster: null,
            center: { lat: -15, lng: -50 },
            zoomLevel: 4,
            isLoading: true,
            abas: ['ocorrencias', 'filtros'],
            abaAtual: 0,
            cMarkers: [],
            filteredMarkers: [],
            visibilityMap: {},
            infoWindow: {
                position: { lat: 0, lng: 0 },
                open: false,
                item: {
                    agrovisita: {},
                    ocorrencia: {},
                },
            },
            isSearching: false,
            colors: [],
            clusterOptions: {
                maxZoom: 12,
                zoomOnClick: true,
                minimumClusterSize: 2,
                styles: [
                    {
                        textColor: 'white',
                        url: '',
                        fontFamily: 'Montserrat,sans-serif',
                        fontWeight: 'normal',
                        height: 45,
                        width: 45,
                    },
                ],
            },
            mapOptions: {
                mapTypeControl: false,
                streetViewControl: false,
                scaleControl: false,
                zoomControl: false,
                fullscreenControl: true,
                fullscreenControlOptions: {
                    position: 7, // google.maps.ControlPosition.RIGHT_TOP
                },
            },
            svgpath:
                'M10.0812 0.00417221V0C10.0537 0 10.0269 0.00166887 10 0.00166887C9.97313 0.00166887 9.94626 0 9.91877 0V0.00417221C4.42628 0.0930404 0 4.64555 0 10.2528C0 17.8089 8.72292 24.9809 10 26C11.2773 24.9811 20 17.8087 20 10.2528C20 4.64555 15.5739 0.0930404 10.0812 0.00417221ZM10.0812 14.663C7.20729 14.663 4.87795 12.2945 4.87795 9.37205C4.87795 6.44879 7.20729 4.0798 10.0812 4.0798C12.9552 4.0798 15.2847 6.44879 15.2847 9.37205C15.2847 12.2945 12.9552 14.663 10.0812 14.663Z',
            msgs: [],
            showOcorrencias: true,
            isOrderedBy: '',
            sortDirection: null, // false == Ascendente, true == Descendente.
            service: null,
            safraService: null,
            culturaService: null,
            agroVisitaItemService: null,
            datainicio: new Date(this.$moment().subtract(30, 'days')),
            datafim: new Date(),
            erroDataInicio: false,
            erroDataFim: false,
            searchVal: '',
            permissao: {},
            tiposocorrencias: [],
            totalItems: 0,
            safraSelected: [],
            safraSelect: [],
            safraLoading: false,
            culturaSelected: [],
            culturaSelect: [],
            culturaLoading: false,
            clientList: [],
            isSaving: false,
        };
    },
    components: {
        Cluster,
    },
    created() {
        this.permissao = this.hasPermissionAccess(
            'agro',
            'geoanalise',
            'mapa-geoanalise-por-ocorrencia'
        );
        this.service = new GeoanaliseOcorrenciaService(this.$http, this.$router);
        this.safraService = new SafraService(this.$http, this.$router);
        this.culturaService = new CulturaService(this.$http, this.$router);
        this.agroVisitaItemService = new AgroVisitaItemService(this.$http, this.$router);

        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'mapa-geoanalise-por-ocorrencia' },
            });

        this.isLoading = true;
        this.colors = paleta.colorList;

        // this.debouncedOnSearch = this.debounce(this.carregarDados, 500);
    },
    mounted() {
        this.isSaving = true;
        /* Espera o google maps carregar, e logo após busca todos os dados das agro-visitas-item para popular o mapa */
        this.$refs.mapRef.$mapPromise.then((map) => {
            this.carregarDados();

            this.clusterOptions.styles[0].url = this.getMapClusterSvg();
            this.cluster = new MarkerClusterer(
                this.$refs.mapRef.$mapObject,
                [],
                this.clusterOptions
            );

            map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(this.$refs.retractBtn);
            map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(
                this.$refs.listaOcorrencias
            );

            setTimeout(() => {
                this.gmnoprintZindex();
                this.isSaving = false;
            }, 1000);
        });
    },
    methods: {
        /* Carrega dados das agro-visitas-itens */
        carregarDados() {
            this.isLoading = true;
            this.filtro.inicio = this.datainicio;
            this.filtro.fim = this.datafim;
            this.filtro.safras =
                this.safraSelected.length > 0 ? this.safraSelected.map((e) => e.id) : [];
            this.filtro.culturas =
                this.culturaSelected.length > 0 ? this.culturaSelected.map((e) => e.id) : [];

            this.service
                .findAll(this.filtro, '')
                .then(this.getMarkers)
                .then(this.mapItemsTiposOcorrencias)
                .then((body) => {
                    this.tiposocorrencias = body != null ? Object.assign([], body) : [];
                    this.isLoading = false;
                    this.$emit('carregadoDados', this.tiposocorrencias, this.clientList);
                })
                .catch((error) => {
                    this.msgs.push(new Message('error', 'msg-erro-relatorio', true));
                    console.error('Erro ao carregar clientes:');
                    console.error(error);
                });
        },
        /* Controla o check de tipo ocorrencia:
            Ao desativar, inativa todos os filhos e subfilhos.
            Ao ativar, ativa todos os filhos e subfilhos.
        */
        toggleTipoOcorrencia(to) {
            this.visibilityMap[to.descricao].visible = this.visibilityMap[to.descricao].checked;

            for (let c in this.visibilityMap[to.descricao]) {
                if (c != 'visible' && c != 'checked' && c != 'inSearch') {
                    this.visibilityMap[to.descricao][c].visible = this.visibilityMap[
                        to.descricao
                    ].visible;

                    for (let d in this.visibilityMap[to.descricao][c]) {
                        if (d != 'visible' && d != 'checked' && d != 'inSearch') {
                            this.visibilityMap[to.descricao][c][d].visible = this.visibilityMap[
                                to.descricao
                            ].visible;
                        }
                    }
                }
            }

            if (this.infoWindow.open && this.infoWindow.item.tipo == s.tipo) {
                this.infoWindow.open = false;
            }

            this.updateMarkers();
        },
        /*
            Controla o check dos usuáros:
            Ao desativar, inativa todos os filhos, e verifica se precisa desmarcar o check pai tambem.
            Ao ativar, ativa todos os filhos e verifica se todos os outros usuarios estão ativados para marcar o check do pai tambem.
         */
        toggleUsuario(to, u) {
            let visible = 0,
                invisible = 0;

            for (let c in this.visibilityMap[to.descricao][u.idusuario]) {
                if (c != 'visible' && c != 'checked' && c != 'inSearch') {
                    this.visibilityMap[to.descricao][u.idusuario][c].visible = this.visibilityMap[
                        to.descricao
                    ][u.idusuario].visible;
                }
            }

            to.usuarios.forEach((c) => {
                this.visibilityMap[to.descricao][u.idusuario].visible ? visible++ : invisible++;
            });

            if (this.infoWindow.open && this.infoWindow.item.idcliente == c.idcliente) {
                this.infoWindow.open = false;
            }

            this.visibilityMap[to.descricao].checked = visible > 0;
            this.visibilityMap[to.descricao].visible = visible > 0;

            this.$refs[`chk-${to.idagro_tipoocorrencia}`][0].indeterminate =
                visible > 0 && invisible > 0;

            this.updateMarkers();
        },
        /*
            Controla o check das Ocorrencias:
            Ao desativar verifica se precisa desmarcar os checks pais tambem.
            Ao ativar verifica se todos as outras ocorrencias estão ativados para marcar o check dos pais tambem.
         */
        toggleOcorrencia(to, u, o) {
            let invisible,
                visible = 0;

            u.ocorrencias.forEach(() => {
                this.visibilityMap[to.descricao][u.idusuario][o.idagro_ocorrencia].visible
                    ? visible++
                    : invisible++;
            });

            if (this.infoWindow.open && this.infoWindow.item.idcliente == c.idcliente) {
                this.infoWindow.open = false;
            }

            this.visibilityMap[to.descricao].checked = visible > 0;
            this.visibilityMap[to.descricao].visible = visible > 0;

            this.visibilityMap[to.descricao][u.idusuario].checked = visible > 0;
            this.visibilityMap[to.descricao][u.idusuario].visible = visible > 0;

            this.$refs[`chk-${to.idagro_tipoocorrencia}-u-${u.idusuario}`][0].indeterminate =
                visible > 0 && invisible > 0;

            this.updateMarkers();
        },
        /*
            Abre os collapses.
        */
        openDetails(s) {
            if (s.hasDetails) {
                s.detailsOpen = !s.detailsOpen;
            }
        },
        /*
            Formata os números mostrados na sidebar.
        */
        format(number) {
            return number.toLocaleString(undefined, {
                style: 'percent',
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            });
        },
        // getDate (d) {
        //     if (d != '' && d != undefined) {
        //         let date = new Date(d);
        //         return date.toLocaleDateString();
        //     } else {
        //         return '';
        //     }
        // },

        /*          
            Organiza os pins para serem inseridos no mapa e possibilitar os pins a serem escondidos ou não quando deselecionar/selecionar os checks na barra lateral.
        */
        getMarkers(body) {
            let m = [];

            let content = body.content;
            if (body.content) {
                content.forEach((s) => {
                    this.visibilityMap[s.descricao] = {};
                    this.visibilityMap[s.descricao].visible = true;
                    this.visibilityMap[s.descricao].checked = true;

                    s.usuarios.forEach((u) => {
                        this.visibilityMap[s.descricao][u.idusuario] = {};
                        this.visibilityMap[s.descricao][u.idusuario].visible = true;
                        this.visibilityMap[s.descricao][u.idusuario].inSearch = true;
                        this.visibilityMap[s.descricao][u.idusuario].checked = true;

                        u.ocorrencias.forEach((o) => {
                            this.visibilityMap[s.descricao][u.idusuario][o.idagro_ocorrencia] = {};
                            this.visibilityMap[s.descricao][u.idusuario][
                                o.idagro_ocorrencia
                            ].visible = true;
                            this.visibilityMap[s.descricao][u.idusuario][
                                o.idagro_ocorrencia
                            ].inSearch = true;
                            this.visibilityMap[s.descricao][u.idusuario][
                                o.idagro_ocorrencia
                            ].checked = true;

                            o.visitas.forEach((v) => {
                                let self = this;
                                let marker = new google.maps.Marker({
                                    idocorrencia: o.idagro_ocorrencia,
                                    idusuario: u.idusuario,
                                    tipoocorrencia: s.descricao,
                                    uuidagrovisitaitem: v.uuid,
                                    visible: true,
                                    position: {
                                        lat: v.latitude,
                                        lng: v.longitude,
                                    },
                                    icon: {
                                        path: this.svgpath,
                                        fillColor: s.cor,
                                        scale: 1,
                                        fillOpacity: 1,
                                        strokeWeight: 0,
                                        anchor: { x: 10, y: 25 },
                                    },
                                });

                                marker.addListener('click', function () {
                                    self.openInfo(marker);
                                });

                                m.push(marker);
                            });
                        });
                    });
                });
            }

            this.cMarkers = m;
            this.filteredMarkers = m;

            this.$refs.mapRef.$mapPromise.then((map) => {
                let bounds = new google.maps.LatLngBounds();

                this.cMarkers.forEach((m2) => {
                    bounds.extend(m2.position);
                });

                map.fitBounds(bounds);
                this.cluster.addMarkers(this.filteredMarkers, true);
            });

            this.updateMarkers();

            return body;
        },
        // getMarkersSearch (body) {
        //     this.cMarkers = [];

        //     body.forEach(s => {
        //         s.clients.forEach(c => {
        //             let self = this;

        //             let marker = new google.maps.Marker({
        //                 idcliente: c.idcliente,
        //                 status: s.tipo,
        //                 visible: true,
        //                 position: {
        //                     lat: c.latitude,
        //                     lng: c.longitude
        //                 },
        //                 icon: {
        //                     path: this.svgpath,
        //                     fillColor: this.colors[0],
        //                     scale: 1,
        //                     fillOpacity: 1,
        //                     strokeWeight: 0,
        //                     anchor: {x: 10, y: 25}
        //                 }
        //             });

        //             marker.addListener('click', function () {
        //                 self.openInfo(marker);
        //             });

        //             this.cMarkers.push(marker);
        //         });
        //     });

        //     this.updateMarkers();

        //     return body;
        // },
        /*
            Mapeia o retorno do servidor, adiciona total de itens nos pais e dados de controle no objeto retornado.
        */
        mapItemsTiposOcorrencias(body) {
            this.clientList = [];
            let content = body.content;

            let total = 0;
            if (content) {
                content.forEach((c) => {
                    c.usuarios.forEach((u) => {
                        u.ocorrencias.forEach((o) => {
                            total += o.visitas.length;
                        });
                    });
                });

                this.totalItems = total;

                return content.map((to) => {
                    let qtdOcorrencias = 0;
                    to.usuarios.forEach((u) => {
                        u.ocorrencias.forEach((o) => {
                            qtdOcorrencias += o.visitas.length;
                        });
                    });

                    return {
                        cor: to.cor,
                        descricao: to.descricao,
                        idagro_tipoocorrencia: to.idagro_tipoocorrencia,
                        imagem: to.imagem,
                        usuarios: to.usuarios.map((us) => {
                            let qtdOcorrenciasUser = 0;
                            us.ocorrencias.forEach((o) => {
                                qtdOcorrenciasUser += o.visitas.length;
                            });

                            return {
                                idusuario: us.idusuario,
                                nome: us.nome,
                                ocorrencias: us.ocorrencias.map((oc) => {
                                    oc.visitas.map((vs) => {
                                        if (!this.clientList.includes(vs.idcliente)) {
                                            this.clientList.push(vs.idcliente);
                                        }
                                    });

                                    return {
                                        idagro_ocorrencia: oc.idagro_ocorrencia,
                                        nomecientifico: oc.nomecientifico,
                                        nomepopular: oc.nomepopular,
                                        visitas: oc.visitas,
                                        hasDetails: true,
                                        detailsOpen: false,
                                        isLoading: false,
                                    };
                                }),
                                hasDetails: true,
                                detailsOpen: false,
                                isLoading: false,
                                qtd: qtdOcorrenciasUser,
                            };
                        }),
                        hasDetails: true,
                        detailsOpen: false,
                        isLoading: false,
                        qtd: qtdOcorrencias,
                    };
                });
            } else {
                return null;
            }
        },

        /* Abre janela de informações ao clicar no pin, busca dados do Pin específico para ser mostrado ao usuário. */
        openInfo(m) {
            this.infoWindow.open = false;
            if (m.uuidagrovisitaitem) {
                this.agroVisitaItemService.findByUuid(m.uuidagrovisitaitem).then((r) => {
                    if (r.content) {
                        this.infoWindow.position = m.position;
                        this.$nextTick(() => {
                            this.infoWindow.open = true;
                        });
                        this.infoWindow.item = r.content;
                        this.infoWindow.item.tipo = m.status;
                    }
                });
            }
        },

        toggleDetails() {
            // Recentraliza a info window ao abrir os detalhes
            this.$refs.mapRef.$mapPromise.then((map) => {
                this.$refs.infoWindow.$infoWindowPromise.then((iw) => {
                    iw.open(map);
                });
            });
        },

        /*
            Atualiza os icones no mapa, leva em consideração quais devem ou não aparecer.
        */
        updateMarkers() {
            this.filteredMarkers = this.cMarkers.filter((m) => {
                // estava tentando acessar registros que não existiam, então adicionei a primeira validação
                return (
                    this.visibilityMap[m.tipoocorrencia][m.idusuario][m.idocorrencia] &&
                    this.visibilityMap[m.tipoocorrencia][m.idusuario][m.idocorrencia].visible &&
                    this.visibilityMap[m.tipoocorrencia][m.idusuario][m.idocorrencia].inSearch
                );
            });

            this.cluster.clearMarkers();
            this.cluster.addMarkers(this.filteredMarkers);
            this.$forceUpdate();
        },

        // orderBy (field, direction, changeSortDirection, list = []){
        //     this.isOrderedBy = field;
        //     if (direction == null){
        //         this.sortDirection = false;
        //         direction = false;
        //     } else if (changeSortDirection) {
        //         this.sortDirection = !direction;
        //     }

        //     if (field == 'nome'){
        //         if (list.length <= 0){
        //             this.status.forEach((sc) => {
        //                 if (sc.clients.length > 0 && sc.clients[0].rsocial){
        //                     sc.clients.sort(this.compareRS);
        //                 }
        //             });
        //         } else {
        //             list.sort(this.compareRS);
        //         }
        //     } else if( field == 'qtd'){

        //     }
        // },

        // compareRS(a, b){
        //     if (!this.sortDirection){ // Ascendente
        //         if (a.rsocial < b.rsocial){
        //             return -1;
        //         }
        //         if (a.rsocial > b.rsocial){
        //             return 1;
        //         }
        //     } else { // Descendente
        //         if (a.rsocial < b.rsocial){
        //             return 1;
        //         }
        //         if (a.rsocial > b.rsocial){
        //             return -1;
        //         }
        //     }
        //     return 0;
        // },

        /*
            Cria os clusters quando zoom for muito baixo.
        */
        checkIfOpenedWindowInCluster() {
            if (this.infoWindow.open) {
                let uuidagrovisitaitem = this.infoWindow.item.uuid;

                setTimeout(() => {
                    this.cluster.getClusters().forEach((c) => {
                        if (c.markers_.length > this.clusterOptions.minimumClusterSize - 1) {
                            c.markers_.some((m) => {
                                if (m.uuidagrovisitaitem == uuidagrovisitaitem) {
                                    this.infoWindow.open = false;
                                }
                                return m.uuidagrovisitaitem == uuidagrovisitaitem;
                            });
                        }
                    });
                }, this.cMarkers.length * 0.2);
            }
        },

        /* Carrega os dados de safra pro filtro de safras. */
        loadSafra(termo) {
            this.safraLoading = true;
            this.safraService
                .findAllCombo(termo)
                .then((body) => {
                    return body.content.map((m) => {
                        return {
                            id: m.idsafra,
                            label: m.descricao,
                        };
                    });
                })
                .then((r) => {
                    this.safraSelect = r;
                    //preenche automaticamente se só tiver um valor
                    if (this.safraSelect.length == 1 && !this.cantEdit && !this.isLoadingEdit) {
                        this.safraSelected = this.safraSelect[0];
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa. Termo: [${termo}]`, e);
                })
                .finally(() => {
                    this.safraLoading = false;
                });
        },

        /* Carrega as culturas pro filtro de culturas */
        loadCultura(termo) {
            this.culturaLoading = true;
            this.culturaService
                .findAllCombo(termo)
                .then((body) => {
                    return body.content.map((m) => {
                        return {
                            id: m.idtipocultura,
                            label: m.descricao,
                        };
                    });
                })
                .then((r) => {
                    this.culturaSelect = r;
                    //preenche automaticamente se só tiver um valor
                    if (this.culturaSelect.length == 1 && !this.cantEdit && !this.isLoadingEdit) {
                        this.culturaSelected = this.culturaSelect[0];
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa. Termo: [${termo}]`, e);
                })
                .finally(() => {
                    this.culturaLoading = false;
                });
        },
        goToDetalhes(uuid) {
            this.$router.push({ name: 'agro-visita-edit', params: { id: uuid } });
        },

        // mapItemsFiltro (body) {
        //     let list = body.content.map(i => {
        //         return {
        //             id: i.id,
        //             label: i.descricao
        //         };
        //     });

        //     return list;
        // },
        // applyFilter () {
        //     this.isSearching = true;

        //     this.filtro = {
        //         atividade: this.atividade != null ? {descricao: this.atividade.label} : null,
        //         situacao: this.situacao != null ? {descricao: this.situacao} : null,
        //         regiao: this.regiao != null ? {descricao: this.regiao.label} : null
        //     };

        //     this.searchClientes(this.searchVal);
        // },
        // searchClientes (val) {
        //     let requests = [];

        //     this.isSearching = true;
        //     this.searchVal = val;

        //     for (var s in this.visibilityMap) {
        //         if (s != 'visible') {
        //             for (var c in this.visibilityMap[s]) {
        //                 if (c != 'visible' && c != 'checked') {
        //                     this.visibilityMap[s][c].inSearch = false;
        //                 }
        //             }
        //         }
        //     }

        //     this.status.forEach(s => {
        //         if (s.hasDetails) {
        //             requests.push(
        //                 this.service.findByStatus(s.tipo, this.filtro, this.searchVal)
        //                     .then(this.mapItems)
        //                     .then(r => {
        //                         s.clients = r;
        //                     })
        //             );
        //         }
        //     });

        //     requests.push(
        //         this.service.findAll(this.filtro, val)
        //             .then(this.mapItemsStatus)
        //             .then(r => {
        //                 let recstatus = [];

        //                 this.status.forEach((s, i) => {
        //                     recstatus = r.find(sr => sr.tipo == s.tipo);

        //                     if (recstatus != undefined) {
        //                         s.qtd = recstatus.qtd;

        //                         this.$nextTick(function() {
        //                             let chk = this.$refs[`chk-${s.tipo}`];
        //                             let visible = 0, invisible = 0;

        //                             for (var c in this.visibilityMap[s.tipo]) {
        //                                 if (c != 'visible' && c != 'checked' && this.visibilityMap[s.tipo][c].inSearch) {
        //                                     this.visibilityMap[s.tipo][c].visible ? visible++ : invisible++;
        //                                 }
        //                             }

        //                             chk[0].indeterminate = visible > 0 && invisible > 0;

        //                             this.visibilityMap[s.tipo].checked = this.visibilityMap[s.tipo].visible && visible > 0;
        //                         });
        //                     }
        //                 });
        //             })
        //     );

        //     // Executado quando todas as requests resolverem
        //     Promise.all(requests).then(() => {
        //         this.updateMarkers();
        //         this.orderBy(this.isOrderedBy, this.sortDirection, false);
        //         this.isSearching = false;
        //     });
        // },

        /* Cria dinamicamente o HTML do icone do Tipo ocorrencia */
        buildIcon(to, useColor) {
            let icon = to.imagem;
            let color = '#000';
            if (useColor) {
                color = to.cor;
            }
            return `<i class="fa-lg ${icon.toLowerCase()}" style="color: ${color}"></i>`;
        },

        gmnoprintZindex() {
            // Removendo o z-index dos avisos de copyright do mapa para o aviso poder aparecer normal e em full screen
            document.querySelectorAll('.gmnoprint').forEach((e) => {
                if (e.style.zIndex) {
                    e.style.zIndex = 0;
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@mixin border() {
    border: 1px solid $table-border;
    border-radius: 3px;
}

#main {
    padding: 0px 20px;
    height: 100%;
}

.page {
    position: relative;
}

.mapa-wrapper {
    .vue-map-container {
        width: 100%;
        height: calc(100vh - 140px);
    }

    .filtros-main {
        padding: 10px 15px;
    }

    .info-window .info-details {
        span {
            font-weight: 900;
        }

        .icon {
            height: auto !important;
            width: auto !important;
        }
    }
}

.control-right {
    .lista-tipoocorrencias {
        width: 100%;
        height: calc(100% - 40px);
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        padding: 0.75rem;

        .search-input {
            opacity: 0.9;
        }

        .table-controls {
            display: flex;
            border: 1px solid $table-border;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            border-bottom: 0;
            height: 1.5rem;
            margin-top: 0.4rem;
            align-items: center;
            font-weight: 600;

            .status-header {
                display: flex;
                align-items: center;
                width: 70%;
                padding-left: 22px;
                justify-content: space-between;
                height: 100%;
                cursor: pointer;

                &:hover {
                    background: $table-border;
                }
            }

            .cliente-header {
                display: flex;
                align-items: center;
                width: 30%;
                justify-content: center;
                height: 100%;

                // &:hover{
                //     background: $table-border;
                // }
            }
        }

        .lista-wrapper {
            height: calc(100% - 2rem);
            margin-bottom: -0.75rem;

            .lista-container {
                border-left: 1px solid $table-border;
                border-right: 1px solid $table-border;
                margin: 0.75rem;
                overflow-y: scroll;

                & > .columns.is-multiline {
                    margin: 0;
                }

                .lista-item,
                .lista-usuarios,
                .lista-ocorrencias {
                    cursor: pointer;

                    .tipos-ocorrencias-info,
                    .usuarios-info,
                    .ocorrencias-info {
                        display: flex;

                        .info-left {
                            display: flex;
                            align-items: center;

                            .check-div {
                                width: 20px;
                                height: 20px;
                                margin-left: 7px;
                            }

                            .text {
                                padding-left: 5px;
                            }
                        }
                        .info-right {
                            display: flex;
                            width: 100%;
                            align-items: center;
                            justify-content: flex-end;
                        }

                        .info-right-item {
                            margin-right: 50px;
                        }
                        .info-right-user {
                            margin-right: 25px;
                        }
                        .info-right-ocorrencia {
                            margin-right: 0px;
                        }
                    }
                }

                .lista-item {
                    padding: 0.25rem;

                    .tipos-ocorrencias-info .info-left,
                    .usuarios-info .info-left,
                    .ocorrencias-info .info-left {
                        width: calc(100% - 100px);
                    }
                }

                .lista-usuarios,
                .lista-ocorrencias {
                    padding: 0.25rem 0 0.25rem 0.75rem;

                    .tipos-ocorrencias-info .info-left,
                    .usuarios-info .info-left,
                    .ocorrencias-info .info-left {
                        width: 100%;
                        align-items: flex-start;
                    }
                }
            }
        }

        .table-count {
            display: flex;
            border: 1px solid $table-border;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            height: 1.5rem;
            align-items: center;
            justify-content: space-around;
            font-weight: 600;
        }
    }

    .button-box {
        .full-size {
            width: 100%;
            text-align: center;
        }

        .no-margin {
            margin: 0;
        }
    }
}

.sub-menu {
    padding-left: 40px;

    .sub-menu {
        padding-left: 7px;
    }
}

.item-detail {
    float: right;
}

@mixin btn() {
    width: 100%;
    padding: 5px;
    margin: 5px 0px;
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    border: none;
    border-radius: 3px;
    outline: none;
}

.btn-expand {
    color: $darker-gray-color;
    @include btn();

    &:active {
        background-color: $darker-bg-color;
    }

    &:hover,
    &:focus {
        background-color: $table-border;
    }
}

.btn-cadastro {
    background-color: $primary-color;
    color: $sovis-white;
    @include btn();

    &:active {
        background-color: $primary-color-click;
    }

    &:hover,
    &:focus {
        background-color: $primary-color-hover;
    }
}

.check-box {
    margin-bottom: 0;
    // margin-left: 5px;

    .checkmark {
        position: inherit;
        display: inline-flex;
        top: 0;
        right: 0;
        height: 16px;
        width: 16px;
        border: 2px solid $primary-color-hover;
        margin-top: 2px;
        border-radius: 3px;
    }
}
</style>
